export default __webpack_public_path__ + "static/media/sap.54576ff2.png";